<div class="">
  
  <div class="content-header">
    <logo [src]="'assets/img/foodbud.png'" [width]="147" [height]="33"></logo>
  </div>

  <div class="row">
    <div class="col-md-4 mar5">
      <div class="card">
        <div class="content-body">
          <router-outlet></router-outlet>
        </div>
      </div>
    
    </div>
  </div>
 
</div>
